import React from 'react';
import { Archive, Trash2 } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from './Alert';

const TaskActionConfirmationModal = ({ isOpen, onClose, onConfirm, action }) => {
  if (!isOpen) return null;

  const config = {
    archive: {
      title: 'Archive Task',
      icon: Archive,
      description: 'This task will be moved to your archives. You can access and restore archived tasks later.',
      confirmLabel: 'Archive',
      confirmClass: 'bg-green-500 hover:bg-green-600',
      alertVariant: 'success'
    },
    delete: {
      title: 'Delete Task',
      icon: Trash2,
      description: 'This action cannot be undone. The task will be permanently deleted from your system.',
      confirmLabel: 'Delete',
      confirmClass: 'bg-red-500 hover:bg-red-600',
      alertVariant: 'destructive'
    }
  };

  const { title, icon: Icon, description, confirmLabel, confirmClass, alertVariant } = config[action];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-xl w-96 max-w-[90vw]">
        <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
          <Icon className={action === 'delete' ? 'text-red-500' : 'text-green-500'} />
          {title}
        </h2>
        
        <Alert variant={alertVariant} className="mb-4">
          <AlertTitle className="font-semibold">Please Confirm</AlertTitle>
          <AlertDescription>{description}</AlertDescription>
        </Alert>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            className="px-4 py-2 bg-gray-100 text-gray-800 rounded hover:bg-gray-200 transition-colors"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className={`px-4 py-2 text-white rounded transition-colors ${confirmClass}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaskActionConfirmationModal;